'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'socks';
var width = 512;
var height = 512;
var aliases = [129510];
var unicode = 'f696';
var svgPathData = ['M0 416c0 53 43 96 96 96 15.4 0 30.5-3.7 44-10.7-17.6-23.9-28-53.4-28-85.3 0-45.3 21.3-88 57.6-115.2l70.4-52.8 0-136-112 0 0 160-89.6 67.2C14.2 357.3 0 385.8 0 416zM128 0l0 64 112 0 0-64-112 0zM288 64l0 48 192 0 0-48-192 0z', 'M288 272l0-160 192 0 0 256-166.4 124.8c-16.6 12.5-36.8 19.2-57.6 19.2-53 0-96-43-96-96 0-30.2 14.2-58.7 38.4-76.8L288 272zM480 64l-192 0 0-64 192 0 0 64zM240 64l0 48-112 0 0-48 112 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSocks = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;